import React from 'react'
import { css } from '@emotion/css'
import { Box, Stack, Typography } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import { useGetOnboardingStepsQuery, OnboardingStepStatus } from '../../api/onboardingApiSlice'
import { ReactComponent as LightbulbIcon } from '../../common/icons/lightbulb.svg'

export default function OnboardingInfoCard() {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const { data: onboardingSteps, isLoading } = useGetOnboardingStepsQuery()

  const isOnboardingPath = pathname.includes('/learn')
  function handleNavigate() {
    navigate('/learn')
  }

  const completedStepsCount =
    onboardingSteps?.filter(step => step.status === OnboardingStepStatus.COMPLETED).length || 0

  const totalStepsCount = onboardingSteps?.length || 0
  const isOnboardingComplete = completedStepsCount === totalStepsCount
  return (
    <div className={glowWrapperStyle}>
      <Box sx={cardSx(isOnboardingPath, isOnboardingComplete)} onClick={handleNavigate}>
        <Stack rowGap={1}>
          <Box display={'flex'} columnGap={1}>
            {isOnboardingComplete && <LightbulbIcon />}
            <Typography sx={titleSx(isOnboardingPath, isOnboardingComplete)}>Learn</Typography>
          </Box>
          {!isOnboardingComplete && <Typography sx={subtitleSx(isOnboardingPath)}>First steps</Typography>}
        </Stack>
        {!isOnboardingComplete && (
          <Box sx={counterWrapper}>
            {isLoading ? (
              <Typography sx={badgeSx}>Loading...</Typography>
            ) : (
              <Typography sx={badgeSx}>
                {completedStepsCount} of {totalStepsCount}
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </div>
  )
}

const glowWrapperStyle = css`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px 0;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 0;
    border-radius: 24px;
    background: linear-gradient(120deg, #fa709a 0%, #fee140 100%);
    filter: blur(32px);
    opacity: 0.7;
    pointer-events: none;
  }
`

const cardSx = (isOnboardingPath, isOnboardingComplete) => {
  return {
    width: '100%',
    minWidth: '220px',
    borderRadius: '12px',
    padding: '8px 16px',
    background:
      isOnboardingPath || (!isOnboardingPath && isOnboardingComplete)
        ? '#fff'
        : 'linear-gradient(90deg, #0246F8 0%, #0E02F8 100%)',
    boxShadow: '0 8px 32px 0 #2616501f',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    direction: 'row',
    display: 'flex',
    cursor: 'pointer'
  }
}

const titleSx = (isOnboardingPath, isOnboardingComplete) => {
  return {
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: isOnboardingComplete ? 400 : 700,
    fontSize: '14px',
    color: isOnboardingPath || (!isOnboardingPath && isOnboardingComplete) ? '#1B1B26' : '#F9F9FB'
  }
}

const subtitleSx = isOnboardingPath => {
  return {
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: 400,
    fontSize: '14px',
    color: isOnboardingPath ? '#76767D' : '#CACACE'
  }
}
const badgeSx = {
  fontFamily: 'Plus Jakarta Sans',
  fontWeight: 700,
  fontSize: '14px',
  color: '#0246F8'
}
const counterWrapper = {
  background: '#E0E9FF',
  borderRadius: '1000px',
  padding: '6px 12px'
}
